import React, { useState } from "react";
import PropTypes from "prop-types";
import { useApplyCouponCodeMutation } from "../campaigns-api-endpoints";
import CampaignGroupPropType from "../campaign-group-prop-type";
import PurchaseFlowModals from "./purchase-flow-modals";

const propTypes = {
  campaignGroup: CampaignGroupPropType.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRefetch: PropTypes.func
};

const RenewPaymentFlow = ({ campaignGroup, isOpen, onClose, onRefetch = () => {} }) => {
  const [couponData, setCouponData] = useState({});
  const [couponErrorData, setCouponErrorData] = useState({});

  const [verifyCouponCode, { isLoading: isVerifying }] = useApplyCouponCodeMutation();

  const handleApplyCoupon = async (couponCode, target) => {
    setCouponErrorData({});
    try {
      const response = await verifyCouponCode({
        applyCouponUrl: target,
        params: { coupon: { code: couponCode }, add_weeks: true }
      }).unwrap();
      setCouponData(response);
    } catch (err) {
      setCouponErrorData(err.data || "Unable to apply coupon");
    }
  };

  return (
    <PurchaseFlowModals
      campaignGroup={campaignGroup}
      purchaseModalData={{
        showPaymentFailNote: false,
        showUpgradeSell: false,
        showOrderSummary: true,
        confirmationButtonText: "Purchase",
        formTarget: campaignGroup.update_card_link,
        hideExistingCards: true,
        applyCouponLink: campaignGroup.apply_coupon_link,
        supportsStripeRetail: true
      }}
      displayPurchaseModal={isOpen}
      setDisplayPurchaseModal={onClose}
      applyCouponCodeCallback={handleApplyCoupon}
      couponData={couponData}
      couponErrorData={couponErrorData}
      isVerifyingCoupon={isVerifying}
      purchaseSource="campaign_results"
      purchaseType="renewal"
      onRefetch={onRefetch}
      supportsStripeRetail
    />
  );
};

RenewPaymentFlow.propTypes = propTypes;

export default RenewPaymentFlow;
